import type { ButtonProps } from "@bonusx-global/bx-design-system";
import { Alignment, Button, Displaying, Typography } from "@bonusx-global/bx-design-system";
import Box from "@mui/material/Box";
import { TwoButtonsWarningModalActionsWrapper } from "./components/two-buttons-warning-modal-actions-wrapper";
import { BigBellExclamationDuotone } from "./components/two-buttons-warning-modal-icon";
import { TwoButtonsWarningModalTextWrapper } from "./components/two-buttons-warning-modal-text-wrapper";
import { TwoButtonsWarningModalWrapper } from "./components/two-buttons-warning-modal-wrapper";

export interface ITwoButtonsWarningModalContentProps {
  title: string;
  subtitle: string;
  firstButtonId: string;
  firstButtonText: string;
  firstButtonVariant?: ButtonProps["variant"];
  firstButtonColor?: ButtonProps["color"];
  secondButtonId: string;
  secondButtonText: string;
  secondButtonVariant?: ButtonProps["variant"];
  secondButtonColor?: ButtonProps["color"];
  firstButtonClick: () => void;
  secondButtonClick: () => void;
}

export function TwoButtonsWarningModalContent({
  title,
  subtitle,
  firstButtonId,
  firstButtonText,
  firstButtonVariant,
  firstButtonColor,
  secondButtonId,
  secondButtonText,
  secondButtonVariant,
  secondButtonColor,
  firstButtonClick,
  secondButtonClick,
}: Readonly<ITwoButtonsWarningModalContentProps>): JSX.Element {
  return (
    <TwoButtonsWarningModalWrapper>
      <Box display={Displaying.flex} alignItems={Alignment.center} justifyContent={Alignment.center}>
        <BigBellExclamationDuotone />
      </Box>

      <TwoButtonsWarningModalTextWrapper>
        <Typography textAlign={Alignment.center} variant="h6">
          {title}
        </Typography>

        <Typography textAlign={Alignment.center} variant="body2">
          {subtitle}
        </Typography>
      </TwoButtonsWarningModalTextWrapper>

      <TwoButtonsWarningModalActionsWrapper>
        <Button
          id={firstButtonId}
          variant={firstButtonVariant ?? "outlined"}
          color={firstButtonColor ?? "primary"}
          onClick={firstButtonClick}
        >
          {firstButtonText}
        </Button>
        <Button
          id={secondButtonId}
          variant={secondButtonVariant ?? "contained"}
          color={secondButtonColor ?? "primary"}
          onClick={secondButtonClick}
        >
          {secondButtonText}
        </Button>
      </TwoButtonsWarningModalActionsWrapper>
    </TwoButtonsWarningModalWrapper>
  );
}
